import BaseCtrl from 'edge/platform/base/BaseCtrl';

var fn = function fn($scope, RenewalService) {

    var ctrl = Object.create(BaseCtrl);

    ctrl.init = function () {
        $scope.updateCoverages = RenewalService.updateCoverages;
    };

    return ctrl.create($scope);
};
fn.$inject = ['$scope', 'transaction.RenewalService'];

export default fn;


//////////////////
// WEBPACK FOOTER
// ./common/js/src/edge/gw-portals-policytransaction-renewal-bop-angular/additionalCoverages/additionalCoveragesCtrl.js
// module id = 1863
// module chunks = 0